<template lang="pug">
  .component-vehicle-controller(v-if="item")
    statistics-card5
      div(slot="n1")
        span Odometer
        h3 {{item.odometer}}{{configuration.locale.locale_distance_unit.value}}
      div(slot="n2")
        span Fuel Level:
        h3 {{item.fuel_level}}%
          span(v-if="item.range !== null") ({{item.range}}{{configuration.locale.locale_distance_unit.value}})
      div(slot="n3")
        span Door Status:
        h3 {{item.door_status}}
      div(slot="n4")
        span Engine Status:
        h3 {{item.engine_status}}
      div(slot="n5")
        span Parking Lot
        router-link(v-if="item.parking_lot.id", :to="{name:'parkingLot', params:{id:item.parking_lot.id}}")
          h3 {{item.parking_lot.name}}
        h3(v-else) --
    .row
      .columns
        router-tab-headers#vehicle-details(:tabs="tabs")
          router-view.content(:item="item")
</template>
<script type="text/babel">
import StatisticsCard5 from 'components/structure/ui/StatisticsCard5'
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import RouterTabHeaders from 'components/structure/foundation/RouterTabHeaders'
import {mapState} from 'vuex'

export default {
  name: 'VehicleController',
  components: {
    RouterTabHeaders,
    StatisticsCard5,
    KeplerBackofficeSdk
  },
  data() {
    return {
      lastUsed: null,
      tabs: [
        {
          headerName: 'Overview',
          name: 'vehicle',
          pathName: 'vehicle'
        },
        {
          headerName: 'Reservations',
          name: 'vehicle-reservations',
          pathName: 'vehicle-reservations'
        },
        {
          headerName: 'Status',
          name: 'vehicle-reports',
          pathName: 'vehicle-reports'
        },
        {
          headerName: 'Maintenance requests',
          name: 'maintenance-requests',
          pathName: 'maintenance-requests'
        },
        {
          headerName: 'Map position',
          name: 'vehicle-position',
          pathName: 'position'
        },
        {
          headerName: 'Costs',
          name: 'vehicle-costs',
          pathName: 'costs'
        },
        {
          headerName: 'Notes',
          name: 'vehicle-notes',
          pathName: 'notes'
        },
        {
          headerName: 'Instructions',
          name: 'vehicle-instructions',
          pathName: 'instructions'
        },
        {
          headerName: 'Attributes',
          name: 'vehicle-attributes',
          pathName: 'attributes'
        },
        {
          headerName: 'Logs',
          name: 'vehicle-logs',
          pathName: 'vehicle-logs'
        },
      ]
    }
  },
  created() {
    /* KeplerBackofficeSdk.vehicles.select(this.$route.params.id).movements((data) => {
         console.log(data)
     })*/
  },
  methods: {},
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    }),
  },
  props: ['item'],

}
</script>
<style lang="sass" rel="stylesheet/sass">
.component-vehicle-controller
  .content
    background: white
</style>



// WEBPACK FOOTER //
// Vehicle.vue?19605039